import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageSection, HTMLParser } from '@gik/ui';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import { usePrivacyPolicy } from '@gik/api/legal/legal';
import LegalSkeleton from './LegalSkeleton';

export const privacyPolicyBlockName = 'legal';

function PrivacyPolicy(): React.ReactElement {
  const bem = bemBlock(privacyPolicyBlockName);
  const { data: privacyPolicyArray, error: privacyPolicyError } = usePrivacyPolicy();
  const privacyPolicy = privacyPolicyArray?.[0];

  const isLoading = !privacyPolicy;
  const isError = isLoading && privacyPolicyError;

  if (isLoading) return <LegalSkeleton />;
  if (isError) return <LegalSkeleton />;

  return (
    <PageSection className={bem()}>
      <HTMLParser rawHtml={privacyPolicy.content.rendered} />
    </PageSection>
  );
}

export default withSuspense(PrivacyPolicy, LegalSkeleton);
